module.exports = "<div class=\"panel-heading\" role=\"tab\" (click)=\"collapse()\">\n  <h4 class=\"panel-title\">\n    <span [translate]=\"label\"></span>\n  </h4>\n</div>\n\n<div class=\"panel-collapse collapse\" [ngClass]=\"{ in: open }\" role=\"tabpanel\" #body>\n  <div class=\"panel-body\">\n    <openlr [id]=\"id\" [inputStyle]=\"inputStyle\" [locationReferencePoint]=\"locationReferencePoint\"></openlr>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/openlr/linear/linear-openlr.component.html
// module id = ./src/app/shared/openlr/linear/linear-openlr.component.html
// module chunks = main